import React, { useContext, memo } from 'react';
import Slider from 'react-slick';

import { ChooseMmtWrapper, WhatweofferWrapper, PortfolioList, SliderOuterWrap, WhyChooseMmtWrap } from './WhyChooseMmtStyles';

import { Container, Heading, SubTitle, GenericP } from 'commonStyles';
import { OrangeBorder } from '../../Styles';
import { isMobileContext } from 'UtilityComponents/Util';
import DisplayContext from 'UtilityComponents/displayContext';
import { SliderArrowNext, SliderArrowPrev } from 'common/SliderArrows/SliderArrows';

const WhyChooseMmt = ({ chooseMmtBusinessData = {}, portfolioData, colorTheme }) => {
	const displayName = useContext(DisplayContext).isMobile;
	const isMobile = isMobileContext(displayName);

	const onPortfolioClick = (url) => () => {
		if (url) {
			window.open(url);
		}
	};

	const settings = {
		arrows: true,
		swipeToSlide: true,
		speed: 500,
		slidesToScroll: 1,
		slidesToShow: 4,
		variableWidth: true,
		infinite: false,
		nextArrow: <SliderArrowNext isMobile={isMobile} customClass='bottomAlign chooseNext' />,
		prevArrow: <SliderArrowPrev isMobile={isMobile} customClass='bottomAlign choosePrev' />,
		responsive: [
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1.2,
					slidesToScroll: 1
				}
			}
		]
	};

	const { businessList = [], heading, descp, subTitle } = chooseMmtBusinessData;
	return (
		<ChooseMmtWrapper colorTheme={colorTheme}>
			<Container>
				<WhatweofferWrapper>
					<OrangeBorder />
					<Heading color={colorTheme === 'dark' ? '#fff' : '#000'} fontSize={`${isMobile ? '24px' : '40px'}`} marBt='16px'>
						{heading}
					</Heading>
					<GenericP
						bottom_M={isMobile ? 16 : 40}
						color={colorTheme === 'dark' ? '#fff' : '#000'}
						fsize='16px'
						line_height='18px'>
						{descp}
					</GenericP>
					<SliderOuterWrap>
						<Slider {...settings}>
							{businessList.map((item) => (
								<WhyChooseMmtWrap colorTheme={colorTheme} key={item.decp} width={item.width}>
									{item.decp}
								</WhyChooseMmtWrap>
							))}
						</Slider>
					</SliderOuterWrap>
					<SubTitle
						f_weight={700}
						color={colorTheme === 'dark' ? '#fff' : '#000'}
						fSize={`${isMobile ? '16px' : '32px'}`}
						bottom_M={`${isMobile ? '16' : '24'}`}>
						{subTitle}
					</SubTitle>
					{portfolioData &&
					<PortfolioList>
						{portfolioData.map((item) => (
							<li key={item.name} onClick={onPortfolioClick(item.url)}>{item.name}</li>
						))}
					</PortfolioList>}
				</WhatweofferWrapper>
			</Container>
		</ChooseMmtWrapper>
	);
};

export default memo(WhyChooseMmt);
